import NotFoundContainer from "@/shared/presentation/containers/not-found";
import React from "react";
export var makeNotFound = function () { return React.createElement(NotFoundContainer, null); };
